import * as React from 'react'
import { UseFormRegister, FieldErrors } from 'react-hook-form'
import { ErrorMessage } from '@hookform/error-message'

import { InputText } from '~/atoms/form/InputText'
import { InputNumber } from '~/atoms/form/InputNumber'

import * as Style from './style.css'

const UNIT_TYPE_MINUTE = 'minute'
const UNIT_TYPE_TIME = 'time'

export interface IProps {
  index: number
  option: IReserveOption
  errors: FieldErrors<IReserveOptionState>
  register: UseFormRegister<IReserveOptionState>
  deleteHandler: (index: number) => void
  changePriceHandler?: () => void
}

export const ReserveOption = ({
  index,
  option,
  errors,
  register,
  deleteHandler,
  changePriceHandler,
}: IProps): JSX.Element => {
  // const hasError = !!errors?.supportEvents?.[index]

  return (
    <div className={Style.ReserveOption}>
      <div className={Style.ReserveOptionHeader}>
        <a
          className={Style.ReserveOptionDelete}
          onClick={() => deleteHandler(index)}
        >
          ×削除
        </a>
      </div>
      <div className={Style.ReserveOptionRow}>
        <div className={Style.ReserveOptionRowName}>
          <div className={Style.ReserveOptionRowNameText}>オプション名</div>
        </div>
        <div className={Style.ReserveOptionRowContent}>
          <div className={Style.ReserveOptionInput}>
            <InputText
              isErrorAlert={
                !!errors?.options && !!errors?.options[index]?.option_name
              }
              placeholder=""
              {...register(`options.${index}.option_name`, {
                onBlur: changePriceHandler,
                required: '入力必須項目です',
              })}
            />
          </div>
          <div className={Style.ReserveOptionInputError}>
            <ErrorMessage
              errors={errors}
              name={`options.${index}.option_name`}
              render={({ message }) => <p>{message}</p>}
            />
          </div>
        </div>
      </div>
      <div className={Style.ReserveOptionRow}>
        <div className={Style.ReserveOptionRowName}>
          <div className={Style.ReserveOptionRowNameText}>
            単価
            {option.unit_type === UNIT_TYPE_TIME && <>(予約あたり)</>}
            {option.unit_type === UNIT_TYPE_MINUTE && <>(1時間あたり)</>}
          </div>
        </div>
        <div className={Style.ReserveOptionRowContent}>
          <div className={Style.ReserveOptionInput}>
            <InputNumber
              isErrorAlert={
                !!errors?.options && !!errors?.options[index]?.unit_price
              }
              step="1"
              unit="円"
              {...register(`options.${index}.unit_price`, {
                onBlur: changePriceHandler,
                required: '入力必須項目です',
              })}
            />
          </div>
          <div className={Style.ReserveOptionInputError}>
            <ErrorMessage
              errors={errors}
              name={`options.${index}.unit_price`}
              render={({ message }) => <p>{message}</p>}
            />
          </div>
        </div>
      </div>
      <div className={Style.ReserveOptionRow}>
        <div className={Style.ReserveOptionRowName}>
          <div className={Style.ReserveOptionInputUnitTypes}>
            <label className={Style.ReserveOptionInputUnitType}>
              <input
                type="radio"
                value="time"
                {...register(`options.${index}.unit_type`, {
                  onChange: changePriceHandler,
                })}
              />
              予約
            </label>
            <label className={Style.ReserveOptionInputUnitType}>
              <input
                type="radio"
                value="minute"
                {...register(`options.${index}.unit_type`, {
                  onChange: changePriceHandler,
                })}
              />
              時間
            </label>
          </div>
        </div>
        {option.unit_type === UNIT_TYPE_MINUTE && (
          <div className={Style.ReserveOptionRowContent}>
            <div className={Style.ReserveOptionInput}>
              <InputNumber
                isErrorAlert={
                  !!errors?.options && !!errors?.options[index]?.hour
                }
                min="0"
                step="1"
                placeholder=""
                unit="時間"
                {...register(`options.${index}.hour`, {
                  pattern: /^\d*$/,
                  onBlur: changePriceHandler,
                })}
              />
            </div>
            <div className={Style.ReserveOptionInputError}>
              <ErrorMessage
                errors={errors}
                name={`options.${index}.hour`}
                render={({ message }) => <p>{message}</p>}
              />
            </div>
            <div className={Style.ReserveOptionInput}>
              <InputNumber
                isErrorAlert={
                  !!errors?.options && !!errors?.options[index]?.minute
                }
                min="0"
                step="1"
                placeholder=""
                unit="分"
                {...register(`options.${index}.minute`, {
                  pattern: /^\d*$/,
                  onBlur: changePriceHandler,
                })}
              />
            </div>
            <div className={Style.ReserveOptionInputError}>
              <ErrorMessage
                errors={errors}
                name={`options.${index}.minute`}
                render={({ message }) => <p>{message}</p>}
              />
            </div>
          </div>
        )}
        {option.unit_type === UNIT_TYPE_TIME && (
          <div className={Style.ReserveOptionRowContent}>
            <div className={Style.ReserveOptionInput}>
              <InputNumber
                isErrorAlert={
                  !!errors?.options && !!errors?.options[index]?.time
                }
                min="0"
                step="1"
                placeholder=""
                unit="回"
                {...register(`options.${index}.time`, {
                  pattern: /^\d*$/,
                  onBlur: changePriceHandler,
                })}
              />
            </div>
            <div className={Style.ReserveOptionInputError}>
              <ErrorMessage
                errors={errors}
                name={`options.${index}.time`}
                render={({ message }) => <p>{message}</p>}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
